import { JobCornSchema } from '@eigtech/restoration-types';
import { CurrentClaimCornSchema } from '@eigtech/shared-corn-helper';
import { z } from 'zod';
export const ProcessingStateSchema = z.object({
    dateCompleted: z.string().datetime().optional(),
    dateRequested: z.string().datetime(),
    entityId: z.union([CurrentClaimCornSchema, JobCornSchema]),
    error: z.string().optional(),
    requestActor: z.string(),
    state: z.string(),
});
